module.exports = __webpack_public_path__ + "static/media/logo2.28400c93.png";